import styled, { css, keyframes } from 'styled-components'

import { Row } from '@desenvolvimento-intuix/ui-grid-system'

export const Header = styled.header.attrs({
  className: 'tabs-header'
})`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const Head = styled.div`
  width: 100%;
  padding: 1rem 2rem;

  border-bottom: 4px solid var(--tabs-header-color);

  backdrop-filter: blur(6px);

  cursor: pointer;

  h1 {
    color: var(--tabs-header-color);
    font-size: 1.2rem;
    margin: 0;
  }

  &.disabled {
    background: var(--tabs-disabled-background);
    border-color: var(--tabs-disabled-color);
    pointer-events: none;
    cursor: initial;

    h1 {
      color: var(--tabs-disabled-color);
    }
  }

  &.selected {
    border-color: var(--tabs-selected-color);

    h1 {
      color: var(--tabs-selected-color);
    }
  }

  &.success {
    border-color: var(--tabs-success-color);

    h1 {
      color: var(--tabs-success-color);
    }
  }

  &.error {
    border-color: var(--tabs-success-color);

    h1 {
      color: var(--tabs-success-color);
    }
  }

  & {
    @media (max-width: 767px) {
      background: #fff;
    }
  }
`

interface IHeaderMenu {
  toggle: boolean
}

export const HeaderMenuWrapper = styled.div`
  width: 100%;
  position: relative;
`

const grow = keyframes`
    0% {
        transform: scaleY(0);
    } 100% {
        transform: scaleY(1);
    }
`

export const HeaderMenu = styled(Row)`
  @media (max-width: 767px) {
    display: none;
  }

  ${(props: IHeaderMenu) =>
    props.toggle &&
    css`
      @media (max-width: 767px) {
        display: flex;
        position: absolute;
        z-index: 10;
        width: 100%;

        animation: ${grow} 0.3s backwards;
        transform-origin: top;
      }
    `}
`
